import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '~common/service/authentication.service';
import { APP_TITLE } from '~common/config/constants';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnInit {
  isCollapsed = false;
  appTitle = APP_TITLE;
  userRole: string;

  userProfile: any;
  serverInfo: any;
  constructor(private authService: AuthenticationService) { }

  ngOnInit(): void {
    this.isCollapsed = false
    this.serverInfo = this.authService.getServerIdentity();
    this.userProfile = this.authService.getProfile();
    this.userRole = this.userProfile.isAdmin ? 'admin':'student'
  }

  sidebarOpen(shouldOpen: boolean){
    this.isCollapsed = !this.isCollapsed
  }

}
